import React from "react";
import classNames from "classnames";

import ListBox from "components/ComboBox";
import ComboBoxItem from "components/ComboBox/ComboBoxItem";

import styles from "./ComboBoxField.module.scss";

interface ComboBoxFieldProps<T> {
  className?: string;
  label: string;
  placeholder?: string;
  selected: ComboBoxItem<T> | ComboBoxItem<T>[] | undefined;
  options: ComboBoxItem<T>[];
  error?: string;
  multiple?: boolean;
  onChange:
    | ((value: ComboBoxItem<T>) => void)
    | ((value: ComboBoxItem<T>[]) => void);
}

const ComboBoxField = <T,>({
  className = "",
  label,
  placeholder,
  selected,
  options,
  onChange,
  multiple = false,
  error,
}: ComboBoxFieldProps<T>) => {
  return (
    <div className={classNames(styles.container, className)}>
      <label className={styles.label}>{label}</label>
      <div className={styles.withError}>
        <ListBox
          unfilled
          lean
          multiple={multiple}
          placeholder={placeholder}
          selected={selected}
          options={options}
          onChange={onChange}
          error={!!error}
        />
        {error && <div className={styles.errorMessage}>{error}</div>}
      </div>
    </div>
  );
};

export default ComboBoxField;
